module.exports = __webpack_public_path__ + "img/IATF-16949-2016.51980399.jpg";